<template>
  <validation-observer ref="formRef" novalidate tag="form">
    <div class="bg-secondary-13 rounded py-3 px-4 mt-3">
      <validation-provider v-slot="{ errors }" rules="required">
        <div class="color-black font-14 my-1">Bitácora de Intervención:</div>
        <custom-text-area
          v-model="model.comment"
          :count-classes="['d-block', 'small-counter', 'text-right']"
          custom-error-msg="El comentario es requerido."
          :error="errors[0]"
          :maxlength="3000"
          placeholder="Escribe un comentario"
          show-char-count
        />
      </validation-provider>
      <div class="d-flex justify-content-between mt-4">
        <div class="d-flex">
          <div class="file-input__container">
            <span class="color-gray-6 d-block font-14">
              Nombre del Documento:
            </span>
            <validation-provider
              v-slot="{ errors }"
              :rules="{ required: !!model.file }"
            >
              <custom-input
                v-model="model.fileAlias"
                custom-error-msg="El nombre del documento es requerido"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div class="file-input__container">
            <span class="color-gray-6 d-block font-14">
              Archivo:
            </span>
            <validation-provider
              v-slot="{ errors }"
              :rules="{ required: !!model.fileAlias }"
            >
              <custom-file-input
                v-model="model.file"
                accept=".pdf"
                custom-error-msg="El documento es requerido"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
        </div>
        <div class="d-flex justify-content-end align-items-center mt-4">
          <action-button
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3 px-3"
            @click="$emit('cancel')"
          />
          <action-button
            i="fas fa-save"
            text="Guardar"
            variant="success px-3"
            @click="save"
          />
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomTextArea from 'CustomTextArea';
import { CustomFileInput } from '@/components/common/index';

export default {
  name: 'BitacoraForm',
  components: {
    CustomInput,
    ActionButton,
    CustomTextArea,
    CustomFileInput,
  },
  props: {
    comment: {
      type: String,
      default: null,
    },
    fileAlias: {
      type: String,
      default: null,
    },
    file: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    model: {
      comment: null,
      fileAlias: null,
      file: null,
    },
  }),
  methods: {
    async save() {
      const isValid = await this.$refs.formRef.validate();
      if (!isValid) return;

      this.$emit('submit', this.model);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-bitacora-action__container {
  background-color: #fafafa;
}

.file-input__container {
  min-width: 200px;
  margin-right: 10px;
}
</style>
